import { jsx as _jsx } from "react/jsx-runtime";
import { IMNLogo, IWTLogo, LILogo, SLLogo } from "@gemini/logos";
export const brandLogoMap = {
    immonet: (_jsx(IMNLogo, { size: "sizing.32", variant: "colored" })),
    immowelt: (_jsx(IWTLogo, { size: "sizing.32", variant: "colored" })),
    immoweltat: (_jsx(IWTLogo, { size: "sizing.32", variant: "colored" })),
    seloger: (_jsx(SLLogo, { size: "sizing.32", variant: "colored" })),
    logicimmo: (_jsx(LILogo, { size: "sizing.32", variant: "colored" })),
};
